import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { safeAnchorHref } from '../../../lib/link';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/** Tokenized inline link with the shared focus treatment and safe built-in URL policy. */ export const SpecraLink = /*#__PURE__*/ React.forwardRef(({ className, href, quiet = false, renderLink, ...props }, ref)=>{
    const linkClassName = cn('rounded-sm underline-offset-4 transition-colors hover:underline', quiet ? 'text-muted-foreground hover:text-foreground' : 'text-brand', specraFocusRing, className);
    if (href && renderLink) return renderLink({
        ...props,
        className: linkClassName,
        href,
        ref
    });
    return /*#__PURE__*/ _jsx("a", {
        ...props,
        className: linkClassName,
        href: href ? safeAnchorHref(href) : undefined,
        ref: ref
    });
});
SpecraLink.displayName = 'SpecraLink';
